// WebSocket connection manager with iOS PWA specific handling
export class WebSocketManager {
  private static instance: WebSocketManager
  private isIOSPWA: boolean = false
  
  private constructor() {
    // Detect iOS PWA
    this.isIOSPWA = this.detectIOSPWA()
    
    if (this.isIOSPWA) {
      console.log('[WebSocketManager] iOS PWA detected, applying specific handling')
      this.setupIOSPWAHandling()
    }
  }
  
  static getInstance(): WebSocketManager {
    if (!WebSocketManager.instance) {
      WebSocketManager.instance = new WebSocketManager()
    }
    return WebSocketManager.instance
  }
  
  private detectIOSPWA(): boolean {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
                        (window.navigator as any).standalone === true
    return isIOS && isStandalone
  }
  
  private setupIOSPWAHandling(): void {
    // Handle app becoming active/inactive
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        console.log('[WebSocketManager] iOS PWA became visible, checking connection')
        // Trigger connection check after a short delay
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('iosPWAResumed'))
        }, 100)
      }
    })
    
    // Handle focus events (iOS specific)
    window.addEventListener('focus', () => {
      console.log('[WebSocketManager] iOS PWA gained focus')
      window.dispatchEvent(new CustomEvent('iosPWAFocused'))
    })
    
    // Keep connection alive with periodic activity
    if (this.isIOSPWA) {
      setInterval(() => {
        if (!document.hidden) {
          // Dispatch keepalive event
          window.dispatchEvent(new CustomEvent('wsKeepalive'))
        }
      }, 30000) // Every 30 seconds
    }
  }
  
  // Force reconnection method for iOS PWA
  forceReconnect(): void {
    if (this.isIOSPWA) {
      console.log('[WebSocketManager] Forcing WebSocket reconnection for iOS PWA')
      window.dispatchEvent(new CustomEvent('wsForceReconnect'))
    }
  }
  
  // Check if we're in iOS PWA mode
  getIsIOSPWA(): boolean {
    return this.isIOSPWA
  }
}

// Initialize on import
export const wsManager = WebSocketManager.getInstance()